import { createStyles, makeStyles } from '@material-ui/core/styles';
import { GREEN } from 'constants/colors';
export default makeStyles(() => createStyles({
  chooseTagRoot: {
    display: 'flex',
    width: '100%',
    textAlign: 'left',
    flexDirection: 'column'
  },
  radio: {
    '&$checked': {
      color: GREEN
    }
  },
  checked: {},
  confirmTag: {
    display: 'flex',
    width: '100%',
    textAlign: 'left',
    justifyContent: 'space-between'
  },
  options: {
    display: 'flex',
    flexDirection: 'column'
  },
  editButton: {
    display: 'flex',
    alignItems: 'flex-end'
  }
}));